import { debounce } from 'lodash'
import { format, isWeekend, isAfter } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { is, date } from 'quasar';

const inputPrecoTotal = () => document.querySelector('[name="gross_amount"]')
const inputQuantidade = () => document.querySelector('#id_quantidade')

const urlNegociacaoAtivos = window.location.origin + '/api/negociacao_ativos/'
const urlMovimentacaoTesouro = window.location.origin + '/api/movimentacao_tesouro/'

export default {

	data() {
		const timeZone = 'America/Sao_Paulo'; // Fuso horário do Brasil
		const currentDate = new Date();
		const zonedDate = zonedTimeToUtc(currentDate, timeZone);
		const formattedDate = format(zonedDate, 'yyyy-MM-dd');
		return {
			situation: '',
			tipo_ativo: '',
			ativoSelecionado: '',
			errorMessage: '',
			showError: false,
			data_response: null,
			acaoModal: 'adicionar',
			dadosAcao: null,
			endpointsArr: ['acoes', 'fiis', 'stocks', 'reits', 'tesouro_direto'],
			endpoint: '',
			baseURL: window.location.origin,
			endpoint: '',
			modalValueIsValid: true,
			hasValueInSearch: false,
			erros: [],
			selectsHasFilled: false,
			inputIsInvalid: false,
			inputValues: {
				ticker_symbol: "",
				quantidade: "",
				data_compra: "",
				preco_total: "",
				corretagem: "",
			},
			btnSave: true,

			options: {
				reverse: true,
				onKeyPress: function (valor, e, field, options) {
					const masks = ['#.##0,00', '###0,00']
					let mask = (valor.length > 4) ? masks[1] : masks[0]
					jQuery('.id_preco_total').mask(mask, options)
				}
			},

			nomeAtivo: '',
			ativoId: '',
			date: new Date().getDate(),
			optionsPadronizadas: [
				{ label: "Ações", value: "Ações", id: 1 },
				{ label: "FIIs", value: "FII - Fundo de Investimento Imobiliário", id: 2 },
				{ label: "Stocks", value: "Stock", id: 3 },
				{ label: "REIT", value: "REIT", id: 4 },
				{ label: "Renda fixa", value: "TesouroDireto", id: 5 },

			],
			isTesouroDiretoPadrao: false,
			optionsDinamicas: [],
			dataAtivo: null,
			isEditing: false,
			selectedOption: null,
			isDesktop: false,
			isLoading: false,
			origem: '',
			naoTemInformacoesDividendo: false,


		}
	},

	mounted() {
		tippy('[data-tippy-content]', {
			// allowHTML: true,
			zIndex: 1000000,
			placement: "bottom-start",
			boundary: "HTMLElement",
		})
		if (localStorage.getItem('lastRoute') === 'reserva-emergencia') {
			setTimeout(() => {
				document.querySelector('[data-xopen="modal-novo-ativo"]').click()
			}, 500);
			localStorage.setItem('lastRoute', null)
		}
	},
	computed: {
		minDate() {
			const currentDate = new Date();
			console.log(currentDate)
			const minYear = currentDate.getFullYear() - 5;
			let min = new Date(currentDate);

			// Se o dia atual for sábado (6) ou domingo (0), ajuste minDate para o próximo dia útil (segunda-feira)
			if (min.getDay() === 6) {
				console.log('SABADO')
				min.setDate(min.getDate() + 2);
			} else if (min.getDay() === 0) {
				console.log('DOMINGO')
				min.setDate(min.getDate() + 1);
			}
			// } else {
			// 	console.log('OUTRO DIA')
			// 	min = new Date(minYear, min.getMonth(), min.getDate());
			// }
			const isStockOrREIT =
				this.tipo_ativo === 'Stock' ||
				this.tipo_ativo === 'REIT' ||
				(this.tipo_ativo && this.tipo_ativo.value === 'Stock') ||
				(this.tipo_ativo && this.tipo_ativo.value === 'REIT');
			// console.log(`${minYear}-${min.getMonth() + 1}-${min.getDate() + 1}`)				
			// if (isStockOrREIT) {
			// 	const dateCorrect = `${min.getDay()}/${min.getMonth() + 1}/${min.getFullYear()}`
			// 	return dateCorrect
			// }
			return ''
		},

		dataCompraFormatada() {
			return this.inputValues.data_compra ? format(new Date(this.inputValues.data_compra), 'dd/MM/yyyy') : ''
		}

	},



	methods: {
		applyMonetaryMask() {
			setTimeout(() => {
				$('.mask-money-fix').maskMoney({
					thousands: '.',
					decimal: ','
				})
			}, 500);
			setTimeout(() => {
				$('.mask-money-int').maskMoney({
					thousands: '.',
					decimal: ',',
					precision: 6
				})
			}, 500);
		},

		disableDates(date) {
			const today = new Date();
			const dayOfWeek = date.getDay(); // obter o dia da semana da data
			return date > today || dayOfWeek === 0 || dayOfWeek === 6; // desabilitar datas maiores que hoje ou em fins de semana
		},

		changeSituation(valor, idSelectTipo, idSelectBusca) {
			this.id_choices_tipo = idSelectTipo;
			this.id_choices_busca = idSelectBusca;
			this.situation = valor;
			this.acaoModal = 'adicionar';
			this.applyMonetaryMask()
		},

		format(date) {
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();

			return `${day}/${month}/${year}`;
		},

		dropdownShouldOpen(VueSelect) {
			if (this.optionsDinamicas.length) {
				return VueSelect.open
			}
			return VueSelect.search.length !== 0 && VueSelect.open
		},

		async getDetalheAtivo(idAtivo, tipo) {
			const endpoint = tipo === 'TesouroDireto' ? 'titulos_tesouro' : 'ativos_variaveis'
			console.log(endpoint)
			try {
				const base = window.location.origin
				const url = `${base}/api/${endpoint}/${idAtivo}/`
				const { data } = await axios.get(url)
				this.dataAtivo = await data
			}
			catch (err) {
				console.log(err)
			}

		},

		async changeSituationDesktop(valor, idSelectTipo, idSelectBusca, e) {
			const ticker = e.currentTarget.getAttribute('data-ticker')?.toLowerCase();
			
			const isTesouroIPCAWithoutNumbers = ticker === 'Tesouro IPCA+'.toLowerCase()

			this.isTesouroDiretoPadrao = isTesouroIPCAWithoutNumbers;
			const id = e.target.closest('.item.adicionar-manualmente').getAttribute('id')
			const tipoAtual = e.target.closest('.item.adicionar-manualmente').getAttribute('data-type')
			await this.getDetalheAtivo(id, tipoAtual)
			this.origem = 'tabela'
			this.isDesktop = true
			this.id_choices_tipo = idSelectTipo;
			this.id_choices_busca = idSelectBusca;
			this.situation = valor;
			this.tipo_ativo = this.optionsPadronizadas.find(({ value }) => value == tipoAtual)
			this.endpoint = this.endpointsArr[this.tipo_ativo == 'TesouroDireto' ? 4 : this.optionsPadronizadas.find(({ value }) => value == tipoAtual).id - 1]
			this.optionsDinamicas = isTesouroIPCAWithoutNumbers && this.situation === 'aporte' ? [] : [{ value: this.dataAtivo.ticker_symbol, label: this.dataAtivo.ticker_symbol, id: this.dataAtivo.id }]
			console.log(isTesouroIPCAWithoutNumbers, this.situation, this.optionsDinamicas, 'OPÇÕES DINAMICAS')
			this.inputValues.ticker_symbol = isTesouroIPCAWithoutNumbers && this.situation === 'aporte' ? '' : { value: this.dataAtivo.ticker_symbol, label: this.dataAtivo.ticker_symbol, id: this.dataAtivo.id }
			this.hasValueInSearch = true
			this.selectsHasFilled = true;
			this.isEditing = true
			this.acaoModal = 'adicionar';
			if (tipoAtual == 'TesouroDireto' && valor == 'aporte') {
				this.setRendaFixa(true)
			}
			this.compareValues()
			this.applyMonetaryMask()
		},

		handleChange(value) {
			this.tipo_ativo = value.label === 'Renda fixa' ? 'TesouroDireto' : value.value;
			this.endpoint = this.endpointsArr[value.id - 1]
			this.hasValueInSearch = false;
			this.optionsDinamicas = [];
			this.inputValues.ticker_symbol = ''
			this.inputValues.quantidade = null
			this.naoTemInformacoesDividendo = false

			if (this.tipo_ativo === 'TesouroDireto') {
				this.setRendaFixa()
			} else {
				this.optionsDinamicas = [];
			}
			this.applyMonetaryMask()
		},

		setRendaFixa: debounce(async function ( isLineRequest = false ) {
			try {
				let data;
				switch (this.situation) {
					case 'ativo':
						const response1 = await fetch(`${this.baseURL}/api/${this.endpoint}/`)
						data = await response1.json();
						break
					case 'aporte':
						// const response2 = !this.isDesktop ? await fetch(`${this.baseURL}/api/titulos_tesouro/`) : await fetch(`${this.baseURL}/api/${this.endpoint}/`)
						const response2 = isLineRequest ? await fetch(`${this.baseURL}/api/${this.endpoint}/?ticker_symbol=IPCA`) : await fetch(`${this.baseURL}/api/${this.endpoint}/`)
						const dadosRecebidos = await response2.json();
						data = dadosRecebidos
						break
					case 'nova_venda':
						const response3 = await fetch(`${this.baseURL}/api/titulos_tesouro/?update_value=0`)
						const dadosNovaVenda = await response3.json();
						data = dadosNovaVenda
						console.log(data)
						break
				}
				this.optionsDinamicas = data.map(({ ticker_symbol }) => {
					return {
						value: ticker_symbol,
						label: ticker_symbol,
					}
				})
			}
			catch (error) {
				GLOBAL.showToastify(error)
				console.error(error)
			}
			finally {
				this.isLoading = false;
			}
		}, 600),

		onSearch(search, loading) {
			if (search.length) {
				loading(true);
				this.getDataOnSearchSelect(loading, search, this);
			}
		},

		isAcaoOuFII(tipoAtivoValue) {
			return tipoAtivoValue === 'Ações' || tipoAtivoValue === 'FII - Fundo de Investimento Imobiliário';
		},

		handleSearchSelect(opcaoSelecionada) {
			if (!opcaoSelecionada || !opcaoSelecionada.value) {
				this.hasValueInSearch = false;
				this.inputValues.ticker_symbol = '';
				return
			}
			this.hasValueInSearch = true
			this.selectsHasFilled = true;
			console.log(this.tipo_ativo, 'TIPO ATIVO')
			console.log('opcaoSelecionada:', opcaoSelecionada, 'origem:', this.origem)
			// Se vem de auto preenchimento (origem tabela) ou é objeto com id, manter como objeto
			// Caso contrário (digitado do zero), extrair apenas o value como string
			if (this.origem === 'tabela' || (typeof opcaoSelecionada === 'object' && opcaoSelecionada.id !== undefined && opcaoSelecionada.id !== null)) {
				// Auto preenchido - manter como objeto para usar ticker_symbol_obj no POST
				this.inputValues.ticker_symbol = opcaoSelecionada;
				console.log('Mantendo como objeto (auto preenchido):', this.inputValues.ticker_symbol)
			} else {
				// Digitado do zero - usar apenas o value como string
				this.inputValues.ticker_symbol = opcaoSelecionada.value;
				console.log('Usando como string (digitado do zero):', this.inputValues.ticker_symbol)
			}
			if (this.isAcaoOuFII(this.tipo_ativo.value)) {
				this.naoTemInformacoesDividendo = !opcaoSelecionada.tem_info_dividendo;
			}


			this.compareValues()
		},

		async compareValues() {
			const isAutoPreenchido = typeof this.inputValues.ticker_symbol === 'object' && this.inputValues.ticker_symbol !== null
			const tickerSymbolValue = isAutoPreenchido
				? this.inputValues.ticker_symbol.value
				: this.inputValues.ticker_symbol
			// const tickerParam = isAutoPreenchido ? 'ticker_symbol_obj' : 'ticker_symbol'
			
			const url = this.tipo_ativo.value === 'TesouroDireto'
				? `${this.baseURL}/api/titulos_tesouro/?ticker_symbol=${encodeURIComponent(tickerSymbolValue)}`
				: `${this.baseURL}/api/ativos_variaveis/?tipo=${this.tipo_ativo.value ? this.tipo_ativo.value : this.tipo_ativo}&ticker_symbol=${tickerSymbolValue}`


			const response = await fetch(url)
			const data = await response.json();

			if (!data) return

			this.dadosAcao = data;
		},

		getDataOnSearchSelect: debounce(async function (loading, search, vm) {
			try {
				let data;
				switch (this.situation) {
					case 'ativo':
						const response1 = await fetch(`${this.baseURL}/api/${this.endpoint}/?ticker_symbol=${search}`)
						data = await response1.json();
						break
					case 'aporte':
						if (this.tipo_ativo.value == 'TesouroDireto' && !this.isDesktop) {
							const response2 = await fetch(`${this.baseURL}/api/titulos_tesouro/?ticker_symbol=${search}`)
							const dadosRecebidos = await response2.json();
							data = dadosRecebidos.filter(({ ticker_symbol }) => ticker_symbol !== 'Tesouro IPCA+')
							break
						}
						else if (this.tipo_ativo.value == 'TesouroDireto' && this.isDesktop) {
							const response4 = await fetch(`${this.baseURL}/api/${this.endpoint}/?ticker_symbol=${search}`)
							const dadosRecebidos = await response4.json();
							data = dadosRecebidos.filter(({ ticker_symbol }) => ticker_symbol !== 'Tesouro IPCA+')
							break

						}
						else {
							const response2 = await fetch(`${this.baseURL}/api/ativos_variaveis/?tipo=${this.tipo_ativo.value ? this.tipo_ativo.value : this.tipo_ativo}&ticker_symbol=${search}`);
							data = await response2.json();
							break
						}

					case 'nova_venda':
						if (this.tipo_ativo.value == 'TesouroDireto') {
							const response3 = await fetch(`${this.baseURL}/api/titulos_tesouro/?update_value=0&ticker_symbol=${search}`)
							const dadosRecebidos = await response3.json();
							data = dadosRecebidos.filter(({ ticker_symbol }) => ticker_symbol !== 'Tesouro IPCA+')

							console.log(data)
							break
						} else {
							console.log('OBJ:', this.tipo_ativo)
							// const tipo = this.tipo_ativo === 'FIIs' ? 'FII - Fundo de Investimento Imobili\xe1rio' : this.tipo_ativo
							const response3 = await fetch(`${this.baseURL}/api/ativos_variaveis/?update_value=0&tipo=${this.tipo_ativo.value ? this.tipo_ativo.value : this.tipo_ativo}&ticker_symbol=${search}`)
							data = await response3.json();
							break
						}

				}


				this.optionsDinamicas = data.map(({ ticker_symbol, tem_info_dividendo, id }) => {
					return {
						value: ticker_symbol,
						label: ticker_symbol,
						tem_info_dividendo,
						id: id 
					}
				})
				loading(false);
				this.isLoading = false;
			}
			catch (error) {
				GLOBAL.showToastify(error)
				console.error(error)
			}
			finally {
				loading(false);
				this.isLoading = false;
			}

		}, 600),

		clearStates() {
			this.tipo_ativo = '';
			this.situation = '';
			this.hasValueInSearch = false;
			this.selectsHasFilled = false;
			this.modalValueIsValid = true;
			this.showError = false;
			this.errorMessage = "";
			this.inputValues = {
				ticker_symbol: "",
				quantidade: "",
				data_compra: "",
				preco_total: "",
				corretagem: "",
			},
			this.isEditing = false,
			this.dataAtivo = null
			this.isDesktop = false
			this.isTesouroDiretoPadrao = false
			this.origem = ''
		},

		preventMinusInsertOnInput(el) {
			if (el.getAttribute('id') !== 'id_data_compra' && el.getAttribute('id') !== 'id_preco_total' && el.getAttribute('id') !== 'id_corretagem') {
				el.value = Math.abs(el.value)
			}
		},

		validateModalFields(event, typeField) {

			if (typeField === 'preco_total') {
				this.onInputPrecoTotal(event)
			} else if (typeField === 'quantidade') {
				this.onInputQuantidade(event)
			}

			console.log(event)

			const self = this
			const isNullish = Object.entries(self.inputValues).some(([key, value]) => {
				if (key == 'corretagem') return
				if (!value) {
					return true
				}

				return false;
			})

			const formatValuesWithPoint = value => { // Formata o valor removendo os pontos das casas de milhar e deixando apenas na penultima
				if (value.includes('.')) {
					let returnValue = value.replaceAll('.', '')
					let returnValueLeng = returnValue.length
					return returnValue.slice(0, returnValueLeng - 2) + '.' + returnValue.slice(returnValueLeng - 2, returnValueLeng)
				} else {
					return value
				}
			}

			const verifyAndShowError = (quantityValue = 0, priceValue) => {

				const qtd = self.inputValues.quantidade.replace(',', '.')
				const price = formatValuesWithPoint(self.inputValues.preco_total)
				
				const quantity = parseFloat(quantityValue.toString().replace(",", "."));
				const isMajor = Number(qtd) > Number(quantity);
				if (isMajor) {
					const valorFormatadoComVirgula = quantity.toLocaleString("pt-BR", {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					});
					const valorFormatado = Number.isInteger(quantity)
						? quantity
						: Math.floor(quantity);

					const tipos = ["Ações", "FII - Fundo de Investimento Imobiliário"];
					self.showError = true;
					self.errorMessage = `Quantidade não pode ser maior que ${
						tipos.includes(self.tipo_ativo.value)
							? valorFormatado
							: valorFormatadoComVirgula
					}`;
					self.btnSave = false;
					return true;
				} else {
					self.showError = false;
					self.errorMessage = null;
					self.btnSave = true;
				}
			}

			if (self.dadosAcao) {
				let dataMap			

				if (self.tipo_ativo == 'TesouroDireto' || self.tipo_ativo.value == 'TesouroDireto') {

					dataMap = self.dadosAcao.some(({ treasury_bonds_quantity, application_value }) => {

						return verifyAndShowError(treasury_bonds_quantity, application_value)
					})
				} else {

					dataMap = self.dadosAcao.some(({ equities_quantity, update_value }) => {
		
						return verifyAndShowError(equities_quantity, update_value)
					})
				}
				console.log(dataMap, isNullish, 'VALORES')
				dataMap || isNullish ? self.modalValueIsValid = false : self.modalValueIsValid = true;

			} else {
				isNullish ? self.modalValueIsValid = false : self.modalValueIsValid = true;
			}
		},

		onCloseModal() {
			this.clearStates();
		},

		onCancelModal() {
			document.querySelector('.close-modal').click()
			this.clearStates();
		},

		async openDeleteModal({ currentTarget }) {
			const tickerAttribute = currentTarget.getAttribute('data-ticker');
			const tickerId = currentTarget.getAttribute('data-ativo-id')
			const tipo = currentTarget.getAttribute('data-tipo')
			this.nomeAtivo = tickerAttribute;
			this.ativoId = tickerId;
			this.tipo_ativo = tipo
		},

		async onDelete() {
			if (!this.ativoId || !this.tipo_ativo) return
			try {
				const formData = new FormData();
				const url = this.tipo_ativo == 'TesouroDireto' ? `${this.baseURL}/deletar-titulo/${this.ativoId}` : `${this.baseURL}/deletar-ativo/${this.ativoId}`
				formData.append('id', this.ativoId)
				formData.append('tipo', this.tipo_ativo)
				const { data } = await axios.post(`${url}`, formData)
				window.location.reload()
			} catch (error) {
				console.error(error)
			}
		},

		validateInput() {
			this.erros = [];
			if (!this.inputValues.quantidade) {
				this.erros.push("Informe a quantidade!")
			}
			if (parseFloat(this.changeToFloatApi(this.inputValues.quantidade)) === 0) {
				this.erros.push("A quantidade deve ser maior que zero!")
			}
			if (!this.inputValues.data_compra) {
				if (this.situation === 'nova_venda') {
					this.erros.push("Informe a data de venda!")
					return
				}
				this.erros.push("Informe a data de compra!")
			}
			if (!this.inputValues.preco_total) {
				if (this.situation === 'nova_venda') {
					this.erros.push("Informe o preço de venda!")
					return
				}
				this.erros.push("Informe o preço de compra!")
			}
			if (parseFloat(this.changeToFloatApi(this.inputValues.preco_total)) === 0) {
				this.erros.push("O preço total deve ser maior que zero!")
			}
			if (!this.inputValues.ticker_symbol) {
				this.erros.push("Informe o ativo!")
			}
		},

		showToastifyOnErrorInputs() {
			if (this.erros.length) {
				this.modalValueIsValid = false;
				this.erros.forEach(i => {
					GLOBAL.showToastify(i, '#DE4B4F')
					return
				});
			}
		},

		formatDate(date) {
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			console.log(day, month, year)
			return `${day}-${month}-${year}`
		},

		changeToFloatApi (valor) {
			if (!valor) return null
			return valor.replaceAll('.', '').replace(',', '.')
		},

		async formatDateMovimentacao(date) {
			return format(new Date(date), 'dd/MM/yyyy')
		},

		async onSubmit({ currentTarget }, tipoSide) {
			try {
				this.erros = [];

				this.validateInput();
				this.showToastifyOnErrorInputs();

				if (this.acaoModal == 'adicionar' && !this.erros.length) {
					this.tipo_ativo.value === 'TesouroDireto' ? await this.postMovimentacaoTesouro(currentTarget, tipoSide) : await this.postNegociacaoAtivos(currentTarget, tipoSide)
				}
			} catch (error) {
				console.error(error);
			}
		},

		async postNegociacaoAtivos(currentTarget, tipoSide) {
			try {				
				const payloadNegociacaoAtivos = {
					side: tipoSide,
					reference_date: this.inputValues.data_compra,
					trade_quantity: this.inputValues.quantidade,
					gross_amount: this.inputValues.preco_total,
					product_type_name: this.tipo_ativo.value
				}

				// ticker_symbol: "",
				// quantidade: "",
				// data_compra: "",
				// preco_total: "",
				// corretagem: "",

				const form = currentTarget.closest("form");

				const productType = document.createElement('input');
				productType.type = 'hidden';
				productType.name = 'product_type_name';
				productType.value = this.tipo_ativo;

				form.appendChild(productType);

				this.isLoading = true;
				// form.submit();

				payloadNegociacaoAtivos.ticker_symbol = typeof this.inputValues.ticker_symbol === 'object' && this.inputValues.ticker_symbol !== null
					? this.inputValues.ticker_symbol.value
					: this.inputValues.ticker_symbol

				payloadNegociacaoAtivos.product_type_name = payloadNegociacaoAtivos.product_type_name?.value || payloadNegociacaoAtivos.product_type_name

				payloadNegociacaoAtivos.reference_date = date.formatDate(payloadNegociacaoAtivos.reference_date, 'YYYY-MM-DD')

				payloadNegociacaoAtivos.trade_quantity = this.changeToFloatApi(payloadNegociacaoAtivos.trade_quantity)

				payloadNegociacaoAtivos.gross_amount = this.changeToFloatApi(payloadNegociacaoAtivos.gross_amount)
				
				await axios.post(urlNegociacaoAtivos, payloadNegociacaoAtivos)

				setTimeout(() => {
					window.location.reload()
				}, 1000);			
			} catch (error) {
				this.isLoading = false;
				console.error(error);
			}
		},

		async postMovimentacaoTesouro(currentTarget, tipoSide) {
			try {
				const payloadMovimentacaoTesouro = {
					reference_date: this.inputValues.data_compra,
					movement_type: tipoSide,
					treasury_bonds_quantity: this.inputValues.quantidade,
					operation_value: this.inputValues.preco_total
				}

				// ticker_symbol: "",
				// quantidade: "",
				// data_compra: "",
				// preco_total: "",
				// corretagem: "",

				const form = currentTarget.closest("form");

				const productType = document.createElement('input');
				productType.type = 'hidden';
				productType.name = 'product_type_name';
				productType.value = this.tipo_ativo;

				form.appendChild(productType);

				this.isLoading = true;
				// form.submit();

				payloadMovimentacaoTesouro.ticker_symbol = typeof this.inputValues.ticker_symbol === 'object' && this.inputValues.ticker_symbol !== null
					? this.inputValues.ticker_symbol.value
					: this.inputValues.ticker_symbol

				payloadMovimentacaoTesouro.reference_date = date.formatDate(payloadMovimentacaoTesouro.reference_date, 'YYYY-MM-DD')

				payloadMovimentacaoTesouro.treasury_bonds_quantity = this.changeToFloatApi(payloadMovimentacaoTesouro.treasury_bonds_quantity)

				payloadMovimentacaoTesouro.operation_value = this.changeToFloatApi(payloadMovimentacaoTesouro.operation_value)

				await axios.post(urlMovimentacaoTesouro, payloadMovimentacaoTesouro)

				setTimeout(() => {
					window.location.reload()
				}, 2000);			
			} catch (error) {
				this.isLoading = false;
				console.error(error);
			}
		},

		removeItemOnList(event) {
			const { currentTarget } = event;
			currentTarget.closest('.item').remove();
		},

		// validateValueInputQuantity(event) {
		// 	const inputValue = event.target.value;
		// 	let numerosValidos = false;
		// 	const removerCaracteres = (string, regexValue) => string.replace(regexValue, '');
		// 	const tiposAConsiderar = ['Ações', 'FII - Fundo de Investimento Imobiliário']
		// 	if (tiposAConsiderar.includes(this.tipo_ativo)) {
		// 		numerosValidos = /^[0-9]+$/.test(inputValue)
		// 		if (!numerosValidos) {
		// 			event.target.value = removerCaracteres(inputValue, /[^0-9]/g)
		// 		}
		// 	} else {
		// 		numerosValidos = /^\d+(,\d{1,5})?$/.test(inputValue)
		// 		if (!numerosValidos) {
		// 			event.target.value = removerCaracteres(inputValue, /[^\d,]|(,\d{3,})|(,\d{1,2}\D)/g)
		// 		}
		// 	}
		// },

		validateValueInputQuantity(event) {
			const inputValue = event.target.value;
			let numerosValidos = false;
			const removerCaracteres = (string, regexValue) => string.replace(regexValue, '');
			numerosValidos = /^[0-9]+$/.test(inputValue)
			if (!numerosValidos) {
				event.target.value = removerCaracteres(inputValue, /[^0-9]/g)
				this.onInputQuantidade(event)
			}
		},

		validateValueInputPrice(event) {
			const inputValue = event.target.value
			const numerosValidos = /^\d+(,\d{1,2})?$/.test(inputValue)
			const removerCaracteres = (string) => string.replace(/[^\d,]|(,\d{3,})|(,\d{1,2}\D)/g, "")
			if (!numerosValidos) {
				event.target.value = removerCaracteres(inputValue)
			}
		},

		onInputPrecoTotal(event) {
			inputPrecoTotal().value = event.target.value
			// inputPrecoTotal().value = this.changeToFloatApi(event.target.value)
			this.inputValues.preco_total = event.target.value
		},

		onInputQuantidade(event) {
			inputQuantidade().value = event.target.value
			// inputQuantidade().value = this.changeToFloatApi(event.target.value)
			this.inputValues.quantidade = event.target.value
		}
	},


	delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django

}






